export default __webpack_public_path__ + "static/media/facebook_light_purple.62f94f56.svg";